import BaseCollection from './base_collection';
import Brand from './brand';

// App.Collections.Brands
export default BaseCollection.extend({
  model: Brand
});
